export default "__VITE_ASSET__BTyncfMo__"